import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipeModule } from '../translate/translate.pipe.module';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { CreateObjectDialogComponent } from './create-object-dialog.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslatePipeModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [CreateObjectDialogComponent],
  providers: [],
  exports: [CreateObjectDialogComponent]
})

export class CreateObjectDialogModule {

}
